import React from 'react'
import { connect } from 'react-redux'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { PlusCircleOutlined } from '@ant-design/icons'
import { Input, Upload, message, Form, Radio } from 'antd'
import { setImageBox, setImageRes, setImageBase } from '../../../../../store/actions'
import api from '../../../../../services/api'
import './index.scss'
import unit from '@/utils/utils'
import { withTranslation } from 'react-i18next'
import { getAuthHeaders } from '@/utils/session'

const FormItem = Form.Item
const mapStateToprops = state => ({
  domain: state.tree.root.config.domain,
  bucket: state.tree.root.config.bucket,
})
const mapDispatchToProps = dispatch => ({
  setBox: function (key: string, value: string, index: number, id: string) {
    dispatch(setImageBox(id, key, value, index))
  },
  setImageRes: function (id: string, fileList: Array<any>) {
    dispatch(setImageRes(id, fileList))
  },
  setBase: (id, key, value) => {
    dispatch(setImageBase(id, key, value))
  },
})
interface configbale {
  images: any
  imgType?: string
  canScroll?: string
  spacing?: string
}

export interface IImageBoxConfigProps {
  config: configbale
  id: string
  setBox: Function
  setImageRes: Function
  setBase: Function
  domain?: string
  bucket?: string
  t: (str: string) => string
}

const ImageBoxConfig = (props: IImageBoxConfigProps) => {
  const { id, config, setBox, setImageRes, domain, bucket, setBase, t } = props
  const { images } = config

  const formItemLayout = {
    labelCol: {
      xs: {
        span: 3,
      },
      sm: {
        span: 3,
      },
    },
    wrapperCol: {
      xs: {
        span: 16,
      },
      sm: {
        span: 16,
      },
    },
  }

  const deleteImage = e => {
    if (images && images.length > 0) {
      let index = -1
      for (let i = 0; i < images.length; i++) {
        if (images[i].url === e.url) {
          index = i
          break
        }
      }
      if (index !== -1) {
        // index
        setBox('', '', index, id)
      }
    }
  }

  const uploadImg = event => {
    const status = event.file.status
    if (status === 'error') {
      message.error(`${event.file.name} file upload failed.`)
    }
    const basePath = domain ? domain : api.baleenUrl
    setImageRes(
      id,
      event.fileList
        .map((file: any) => {
          if (file.status === 'done') {
            if (file.url) {
              return file
            }
            return {
              url: `${basePath}/${file.response.name}?jpg/interlace,1`, //图片渐进加载
              uid: file.uid,
              status: 'done',
            }
          }
          return file
        })
        .filter((f: { status: string } | any) => f.status !== 'error')
    )
  }
  const setImageLink = (type: string, event, index?: number) => {
    setBox(type, event.target.value, index, id)
  }
  const uploadProps = {
    className: 'upload_item',
    name: 'content',
    action: api.uploadImg,
    showUploadList: true,
    fileList: images ? images : [],
    data: {
      format: 'jpg',
      fulldim: '300x300',
      path: 'a.jpg',
      bucket: 'baleen',
    },
    headers: getAuthHeaders() as Record<string, string>,
    beforeUpload: file => {
      const isJPG =
        file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif'
      if (!isJPG) {
        message.error('You can only upload JPG/PNG file!')
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        message.error('Image must smaller than 2MB!')
      }
      uploadProps.data.path = `${unit.generateImgName()}.${file.name.split('.')[1]}`
      if (bucket) uploadProps.data.bucket = bucket
      return isJPG && isLt2M
    },
    onRemove: e => deleteImage(e),
  }
  return (
    <div className="image-box-config" style={{ marginLeft: 20 }}>
      <Form>
        <FormItem {...formItemLayout} label={t('imageHeader')}>
          <Radio.Group
            onChange={e => setBase(id, 'imgType', e.target.value)}
            value={config.imgType || 'block'}
          >
            <Radio value={'full'}>{t('yes')}</Radio>
            <Radio value={'block'}>{t('no')}</Radio>
          </Radio.Group>
        </FormItem>
        <FormItem {...formItemLayout} label={t('imagesScrollable')}>
          <Radio.Group
            onChange={e => setBase(id, 'canScroll', e.target.value)}
            value={config.canScroll || 'false'}
          >
            <Radio value={'true'}>{t('yes')}</Radio>
            <Radio value={'false'}>{t('no')}</Radio>
          </Radio.Group>
        </FormItem>
        <FormItem {...formItemLayout} label={t('imagesMargin')}>
          <Radio.Group
            onChange={e => setBase(id, 'spacing', e.target.value)}
            value={config.spacing || 'false'}
          >
            <Radio value={'true'}>{t('yes')}</Radio>
            <Radio value={'false'}>{t('no')}</Radio>
          </Radio.Group>
        </FormItem>
        <FormItem {...formItemLayout}>
          <div className="upload_form" key={`uploadItem`}>
            <Upload {...uploadProps} listType="picture-card" onChange={uploadImg}>
              <PlusCircleOutlined className="add_icon" twoToneColor="#1377cc" />
            </Upload>
          </div>
        </FormItem>
        <h3 className="deeplink_title">images links</h3>
        {images &&
          images.map((item, index) => {
            return (
              <FormItem {...formItemLayout} label={`#${index + 1}`} key={`link-${index + 1}`}>
                <Input
                  addonBefore="deeplink"
                  value={item.deeplink || ''}
                  className="image_link_input"
                  key={`input-${index + 1}`}
                  onChange={e => setImageLink('deeplink', e, index)}
                />
                <Input
                  addonBefore="normalLink"
                  value={item.normallink || ''}
                  className="image_link_input"
                  key={`input-nor-${index + 1}`}
                  onChange={e => setImageLink('normallink', e, index)}
                />
              </FormItem>
            )
          })}
      </Form>
    </div>
  )
}

export default connect(mapStateToprops, mapDispatchToProps)(withTranslation()(ImageBoxConfig))
